package devxertech.com.pages.dashboard

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.dashboard.aboutUsSection.AboutUsSection
import devxertech.com.pages.dashboard.clientFeedbackSection.ClientFeedback
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.headerSection.HeaderSection
import devxertech.com.pages.dashboard.portFolioSection.PortfolioSection
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.dashboard.serviceAndTechSection.ServicesSection
import devxertech.com.pages.dashboard.softwareDevelopmentSection.SoftwareDevelopment
import devxertech.com.pages.dashboard.teamOfferSection.TeamOfferSection
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/homepage")
@Composable
fun Dashboard(){
    val sitePalette = ColorMode.current.toSitePalette()
   val breakpoint = rememberBreakpoint()


    Column (modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)){
        val headerPic = listOf(
            Res.Image.header_vector_first,
            Res.Image.header_vector_second
        )
        val headerPicSource = headerPic.random()
        CommonHeader(
            breakpoint = breakpoint,
            image =  headerPicSource,
            headingText = "Think Big.\n" +
                    "We Make it Possible!",
            descriptionText = "Your Ideas will get their desired form- Website, Mobile app or" +
                    " anything Technical, let Devxer Technologies lead the way"
        )
        AboutUsSection(breakpoint)
        ServicesSection(breakpoint )
        TeamOfferSection()
        SoftwareDevelopment(breakpoint)
        PortfolioSection()
        ClientFeedback(breakpoint)
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)

    }
}






